import Resource from './resource';
import request from "../utils/request";

class TaskCards extends Resource {
    constructor() {
        super('task_cards');
    }

    list(params) {
        return request({
            url: `/task_cards/list`,
            method: 'POST',
            params
        })
    }

    store(resource) {
        return request({
            url: `/task_cards/store`,
            method: 'POST',
            data: resource
        })
    }

    update(id, resource) {
        return request({
            url: `/task_cards/update/${id}`,
            method: 'POST',
            data: resource
        })
    }

    delete(id) {
        return request({
            url: `/task_cards/delete/${id}`,
            method: 'DELETE',
        })
    }

    restore(id) {
        return request({
            url: `/task_cards/restore/${id}`,
            method: 'POST',
        })
    }
}

export { TaskCards as default };
